import { Mail, Instagram, Facebook } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-lws-navy text-lws-paper py-24 px-6" data-testid="footer">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-16">
        <div className="md:col-span-2 space-y-8">
          <h2 className="text-4xl font-serif tracking-tighter leading-tight">
            Letter Writers Society
          </h2>
          <p className="text-lws-paper/70 max-w-md leading-relaxed font-light">
            A human-first, ritual-based correspondence society built in response to disposable digital communication. 
            Reclaiming the lost art of letter writing.
          </p>
          <div className="flex space-x-6">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="hover:text-lws-amber transition-colors" aria-label="Instagram"><Instagram size={20} /></a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="hover:text-lws-amber transition-colors" aria-label="Facebook"><Facebook size={20} /></a>
            <a href="mailto:hello@letterwriterssociety.com" className="hover:text-lws-amber transition-colors" aria-label="Email"><Mail size={20} /></a>
          </div>
        </div>

        <div className="space-y-6">
          <h4 className="text-xs uppercase tracking-widest font-semibold text-lws-amber">The Society</h4>
          <ul className="space-y-4 text-sm font-light text-lws-paper/60">
            <li><a href="#membership" className="hover:text-lws-paper transition-colors">Membership</a></li>
            <li><a href="#chapters" className="hover:text-lws-paper transition-colors">Local Chapters</a></li>
            <li><a href="#events" className="hover:text-lws-paper transition-colors">Upcoming Events</a></li>
            <li><a href="#journal" className="hover:text-lws-paper transition-colors">The Journal</a></li>
          </ul>
        </div>

        <div className="space-y-6">
          <h4 className="text-xs uppercase tracking-widest font-semibold text-lws-amber">Support</h4>
          <ul className="space-y-4 text-sm font-light text-lws-paper/60">
            <li><a href="#shop" className="hover:text-lws-paper transition-colors">The Shop</a></li>
            <li><a href="#contact" className="hover:text-lws-paper transition-colors">Contact Us</a></li>
            <li><a href="#about" className="hover:text-lws-paper transition-colors">Our Philosophy</a></li>
            <li><a href="#privacy" className="hover:text-lws-paper transition-colors">Privacy Policy</a></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-24 pt-8 border-t border-lws-paper/10 flex flex-col md:flex-row justify-between items-center text-[10px] uppercase tracking-[0.3em] text-lws-paper/30">
        <p>© 2026 Letter Writers Society. All rights reserved.</p>
        <p>Designed for humans, not algorithms.</p>
      </div>
    </footer>
  );
}
